import React from "react";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import {Card, CardContent, Tooltip} from "@material-ui/core";
import API from "@beardeddevops/react.api";

import APPCONFIG from "constants/Config";
import CollectionOverride from "components/CollectionOverride";
import {Link} from "react-router-dom";


class LocationsBoundBookDownloads extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Locations_Bound_Books_Flags._name, API.RequestType.READ_ALL);
		super(props, model);
		model.grandparent = this.props.id;


	};


	render() {
		const {data, pages, limit, loading} = this.state;
		let {isAdmin} = this.props.rootState;
		const columns = [
			// {
			// 	Header: "Bound Book",
			// 	id: "location_bound_books",
			// 	/** @param {Locations_Bound_Books_Flags} obj */
			// 	accessor: (obj) => {
			// 		return obj.transaction_entry ? obj.transaction_entry : ' '
			// 	},
			// },
			{
				Header: "ID",
				id: 'id',
				/** @param {Locations_Bound_Books_Flags} obj */
				accessor: (obj) => {
					return obj.pkey
				}
			},

			{
				Header: "Location",
				id: "location",
				/** @param {Locations_Bound_Books_Flags} obj */
				accessor: (obj) => {
					return obj.locations ? obj.locations.name : obj.location;
				},
			},
			{
				Header: "Date Flagged",
				id: "date",
				accessor: obj => {
					return obj.date ? moment(obj.date)
						.local()
						.format("MM/DD/YYYY") : 'N/A'
				}
			},
			{
				Header: 'Serial',
				accessor: 'serial_number',
			},
			{
				Header: 'Manufacturer',
				accessor: 'manufacturer_other',
			},
			{
				Header: 'Model',
				accessor: 'model',
			},
			{
				Header: 'Type',
				accessor: 'gun_type',
			},
			{
				Header: 'Caliber',
				accessor: 'caliber_other',
			},
			{
				Header: 'Status',
				accessor: 'status'
			},
			{
				Header: 'Notes',
				accessor: 'note'
			},
			{
				Header: "D",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/** @param {Locations_Bound_Books_Flags} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.status === 'Sold' &&
								<Link to={`/dispositions/${props.original.transaction_entry_binary_id}-${props.original.transaction_entry}`}>
								<Tooltip title={'Disposition'} placement={'top-end'}>
									<Button  color="green-meadow" size="sm" block={true} >
										<i className="fa fa-upload"/>
									</Button>
								</Tooltip>
							</Link>}
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Bound Books')}
							{this.renderHeaderRight("Bound Books", columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(LocationsBoundBookDownloads);
